'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEqual = isEqual;
exports.isString = isString;
exports.isNumber = isNumber;
exports.isBoolean = isBoolean;
exports.isUndefined = isUndefined;
exports.isNull = isNull;
exports.isNullOrUndefined = isNullOrUndefined;
exports.isObject = isObject;
exports.isArray = isArray;
exports.isNodeList = isNodeList;
exports.isFunction = isFunction;
/**
 * 数据类型检查
 */

/**
 * 简单判断两个值的类型 是否相等
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean} isEqual
 */
function isEqual(obj1, obj2) {
  return Object.prototype.toString.call(obj1) === Object.prototype.toString.call(obj2);
}

function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isNumber(obj) {
  return Object.prototype.toString.call(obj) === '[object Number]';
}

function isBoolean(obj) {
  return Object.prototype.toString.call(obj) === '[object Boolean]';
}

function isUndefined(obj) {
  return Object.prototype.toString.call(obj) === '[object Undefined]';
}

function isNull(obj) {
  return Object.prototype.toString.call(obj) === '[object Null]';
}

function isNullOrUndefined(obj) {
  return isNull(obj) || isUndefined(obj);
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function isNodeList(obj) {
  return Object.prototype.toString.call(obj) === '[object NodeList]';
}

function isFunction(obj) {
  return Object.prototype.toString.call(obj) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/objectType.js
// module id = 41
// module chunks = 0